
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1fcus_17rkq_145",
  "clickable": "awsui_clickable_1fcus_17rkq_154",
  "precise": "awsui_precise_1fcus_17rkq_158",
  "focus-outline": "awsui_focus-outline_1fcus_17rkq_162",
  "application": "awsui_application_1fcus_17rkq_171"
};
  